import React from 'react';

const Firecracker = ({ width = 400, height = 500, autoPlay = true }) => {
  return (
    <div style={{
      position: 'relative',
      width: `${width}px`,
      height: `${height}px`,
      margin: '0 auto',
      transformOrigin: 'top',
      padding: '10px',
      overflow: 'hidden',
      display: 'inline-block'
    }}>
      <style>{`
        @keyframes ranshao {
          90% {
            opacity: 1;
            height: 60px;
          }
          100% {
            opacity: 0;
            height: 60px;
          }
        }

        @keyframes drop {
          80%, 100% {
            transform: scale(0.3) rotate(0deg) translateY(2000px);
            opacity: 0;
          }
        }

        @keyframes twikle {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0.2;
          }
        }

        ${Array.from({ length: 50 }, (_, i) => {
          const der = (i % 2 === 0 ? -1 : 1) * Math.floor(Math.random() * 100);
          return `
            @keyframes move${i} {
              30% {
                transform: translate(${der}px, -${Math.floor(Math.random() * 100)}px);
                opacity: 0.8;
              }
              100% {
                transform: translate(${der}px, ${Math.floor(Math.random() * 200) + 10}px);
                opacity: 0;
              }
            }
          `;
        }).join('\n')}

        .firecracker-main {
          width: 2px;
          height: 180px;
          background: black;
          margin: 40px auto;
          position: relative;
          box-shadow: 0 0 1px black;
          animation: ${autoPlay ? 'ranshao 2s forwards' : 'none'};
        }

        .firecracker-container {
          position: absolute;
          transform-origin: top;
          animation: ${autoPlay ? 'drop 1s forwards' : 'none'};
          filter: contrast(120%);
        }

        .firecracker-container:nth-child(2n) {
          left: -28px;
        }

        .firecracker-container:nth-child(2n + 1) {
          right: -28px;
        }

        .firecracker-item {
          margin: 10px;
          position: relative;
          width: 40px;
          height: 100px;
          background: linear-gradient(90deg, #6e0009, #e64743, #6e0009);
        }

        .firecracker-item::before,
        .firecracker-item::after {
          content: '';
          position: absolute;
          display: inline-block;
          width: 38px;
          height: 20px;
          border-radius: 50%;
        }

        .firecracker-item::before {
          width: 40px;
          top: -10px;
          background: linear-gradient(90deg, #6e0009, #e64743, #6e0009);
        }

        .firecracker-item::after {
          left: 1px;
          bottom: -9px;
          background: #9f6f2d;
          border: 1px solid #58301b;
          outline: 1px solid #9f6f2d;
        }

        .firecracker-cicle {
          position: absolute;
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #9f6f2d, #dfa351, #9f6f2d);
          border-radius: 50%;
        }

        .firecracker-cicle::before {
          content: '';
          position: absolute;
          display: inline-block;
          top: 3px;
          width: 100%;
          height: 20px;
          border-radius: 50%;
          background: linear-gradient(90deg, #6e0009, #e64743, #6e0009);
        }

        .firecracker-cicle-top {
          top: -6px;
        }

        .firecracker-cicle-bottom {
          top: 82px;
        }

        .firecracker-last-one {
          transform: scale(0.4) rotate(10deg);
          bottom: -122px;
        }

        ${Array.from({ length: 40 }, (_, i) => {
          const index = i + 1;
          const angle = (i % 2 === 0 ? -1 : 1) * (Math.floor(Math.random() * 70) + (index <= 20 ? 20 : 7));
          const top = 14 + (index <= 20 ? index : index - 20) * 8;
          const delay = index <= 20 ? (20 - index) * 0.08 : (40 - index) * 0.1;
          
          return `
            .firecracker-container:nth-child(${index}) {
              top: ${top}px;
              transform: scale(0.4) rotate(${angle}deg);
              animation-delay: ${delay}s;
            }
          `;
        }).join('\n')}

        .firecracker-fire {
          width: 4px;
          height: 4px;
          bottom: 0;
          background: red;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          box-shadow: 0 0 4px red, 0 0 10px red, 0 0 20px red;
          border-radius: 50%;
        }

        .firecracker-spot-wrap {
          position: absolute;
          bottom: -160px;
          left: 50%;
          transform: translateX(-50%);
          width: 200px;
          height: 200px;
        }

        .firecracker-spot {
          position: absolute;
          background: radial-gradient(rgba(253, 244, 16, 0.6), rgba(253, 244, 16, 0.1));
          box-shadow: 0 0 20px rgba(253, 244, 16, 0.6);
          border-radius: 50%;
          animation: ${autoPlay ? 'twikle 1.2s infinite alternate' : 'none'};
        }

        ${Array.from({ length: 50 }, (_, i) => `
          .firecracker-spot:nth-child(${i + 1}) {
            width: ${Math.floor(Math.random() * 20) + 20}px;
            height: ${Math.floor(Math.random() * 20) + 16}px;
            top: ${Math.floor(Math.random() * 150) + 10}px;
            left: ${Math.floor(Math.random() * 160) + 10}px;
            animation-delay: -${Math.floor(Math.random() * 4)}s;
          }
        `).join('\n')}

        .firecracker-suipian-wrap {
          position: absolute;
          bottom: -160px;
          left: 50%;
          transform: translateX(-50%);
          width: 160px;
          height: 160px;
        }

        .firecracker-suipian {
          position: absolute;
          animation: ${autoPlay ? '0.8s infinite' : 'none'};
        }

        ${Array.from({ length: 50 }, (_, i) => {
          const index = i + 1;
          const clipPath = 
            index % 3 === 0 ? `polygon(${Math.random() * 100}% 0%, ${Math.random() * 100}% 10%, ${Math.random() * 100}% 80%, 0% 60%)` :
            index % 4 === 0 ? `polygon(${Math.random() * 100}% 0%, ${Math.random() * 100}% 10%, ${Math.random() * 100}% 40%, 0% 20%)` :
            index % 10 === 0 ? 'circle(24%)' :
            `polygon(${Math.random() * 40}% 0%, ${Math.random() * 100}% 10%, ${Math.random() * 100}% 80%, ${Math.random() * 80}% 60%, 0% 20%)`;
          
          return `
            .firecracker-suipian:nth-child(${index}) {
              width: ${Math.floor(Math.random() * 6) + 8}px;
              height: ${Math.floor(Math.random() * 6) + 8}px;
              top: ${Math.floor(Math.random() * 120) + 6}px;
              left: ${Math.floor(Math.random() * 120) + 6}px;
              background: rgba(${Math.floor(Math.random() * 100) + 155}, ${Math.floor(Math.random() * 100)}, ${Math.floor(Math.random() * 100)}, 1);
              clip-path: ${clipPath};
              animation-name: move${i};
              animation-delay: -${Math.floor(Math.random() * 4)}s;
            }
          `;
        }).join('\n')}
      `}</style>

      <div className="firecracker-main">
        {Array.from({ length: 40 }, (_, i) => (
          <div key={i} className="firecracker-container">
            <div className="firecracker-item">
              <div className="firecracker-cicle firecracker-cicle-top" />
              <div className="firecracker-cicle firecracker-cicle-bottom" />
            </div>
          </div>
        ))}
        <div className="firecracker-container firecracker-last-one">
          <div className="firecracker-item">
            <div className="firecracker-cicle firecracker-cicle-top" />
            <div className="firecracker-cicle firecracker-cicle-bottom" />
          </div>
        </div>
        <div className="firecracker-fire" />
        <div className="firecracker-spot-wrap">
          {Array.from({ length: 50 }, (_, i) => (
            <div key={i} className="firecracker-spot" />
          ))}
        </div>
        <div className="firecracker-suipian-wrap">
          {Array.from({ length: 50 }, (_, i) => (
            <div key={i} className="firecracker-suipian" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Firecracker;
